/* eslint-disable @typescript-eslint/no-explicit-any */
import {initializeApp} from "firebase/app";
import {getAuth, onAuthStateChanged, signInWithEmailAndPassword, signOut} from "firebase/auth";
import jwt_decode from "jwt-decode";
import developFirebaseConfig from '../../firebase-seoyonehwa.json';
//import productionFirebaseConfig from '../../firebase-production.json';
// import localFireBaseConfig from '../../firebase-develop.json'

export interface IToken {
  role: string,
  user_id: string,
  uidDB: string
}

let firebaseConfig: any = developFirebaseConfig;

switch (process.env.VUE_APP_APP_ENVIRONMENT) {
  case 'local':
    firebaseConfig = developFirebaseConfig;
    break;
  case 'development':
    firebaseConfig = developFirebaseConfig;
    break;
  case 'production':
    firebaseConfig = developFirebaseConfig;
    break;
}

initializeApp(firebaseConfig);

const auth = getAuth();

const initializeAuth = new Promise(resolve => {
  onAuthStateChanged(auth,(user) => {
    authService.setUser(user);
    resolve(user);
  });
});

const authService = {
  auth: auth,
  user: null,

  authenticated() {
    return initializeAuth.then((user: any) => {
      return user && !user.isAnonymous;
    });
  },

  async getToken() {
    return this.auth.currentUser?.getIdToken();
  },

  async getIdFromToken() {
    const token = await this.getToken();
    const decodedToken: IToken = jwt_decode(token ?? '');
    return decodedToken.user_id;
  },

  async getRole() {
    const token = await this.getToken();
    const decodedToken: IToken = jwt_decode(token ?? '');
    return decodedToken.role
  },

  checkRoles(roles: string[]) {
    const decodedToken: IToken = jwt_decode(this.user ? this.user['accessToken'] : '');
    return roles.includes(decodedToken.role);
  },

  setUser(user: any) {
    this.user = user;
  },

  async login(email: string, password: string) {
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const userType = await this.getRole();

      if (userType === 'gogAdmin') {
        this.setUser(userCredential.user);
      } else {
        this.logout();
        const roleMissmatchError: any = new Error();
        roleMissmatchError.code = 'role-missmatch';
        throw roleMissmatchError;
      }
      this.setUser(userCredential.user);
    } catch (error: any) {
      switch (error['code']) {
        case 'auth/user-not-found':
          throw new Error("User has not been found");
        case 'auth/invalid-email':
          throw new Error("e-mail is not registered in the system");
        case "auth/wrong-password":
          throw new Error("Wrong password");
        case "auth/too-many-requests":
          throw new Error("You've attempted to log in multiple times in a short span. Try again later");
        case "role-missmatch":
          throw new Error("Please make sure this e-mail is registered as an administrator");
        default:
          throw new Error("There was an error trying to login");
      }
    }
  },

  async logout() {
    try {
      await signOut(auth);
      this.setUser(null);
    } catch (e) {
      console.log({e});
    }
  },
}

export default authService;
